<!--配色管理-配色列表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="statusList"
          :value.sync="queryParams.status"
          :selectData="statusList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
        <global-select
          slot="createBy"
          :value.sync="queryParams.createBy"
          selectType="selectSearch"
          requestApi="/mes/mesDiscreteJobs/founderBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="jobCode"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" :loading="loading" v-hasPermi="['mdm:materialMatchColorPrepareConfig:import']" @click="handleImport">导入</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['mdm:materialMatchColorPrepareConfig:export']" @click="handleExport">导出</a-button>
        <import-excel ref="importExcelRef" :downloadParams="downloadParams" :uploadParams="upload" @refresh="() => handleOk(false)" />
        <download-modal :apiFun="apiMaterialMatchColorPrepareConfigExport" ref="download" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1600 }">
          <!-- 材料编码2(辅) -->
          <template slot="secondaryItemCode" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.secondaryItemCode }}</span>
            <a-input v-else v-model="record.secondaryItemCode" :maxLength="50" />
          </template>
          <!-- 数量(主) -->
          <template slot="qty" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.qty }}</span>
            <a-input v-else v-model="record.qty" :maxLength="50" />
          </template>
          <!-- TO号 -->
          <template slot="toNo" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.toNo }}</span>
            <a-input v-else v-model="record.toNo" :maxLength="50" />
          </template>
          <!-- 批次号(主) -->
          <template slot="primaryBatchNo" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.primaryBatchNo }}</span>
            <a-input v-else v-model="record.primaryBatchNo" :maxLength="50" />
          </template>
          <!-- 状态 -->
          <template slot="status" slot-scope="{ record }">
            <span v-if="!isEdit || currentId !== record.id">{{ record.statusName }}</span>
            <global-select
              v-else
              :value.sync="record.status"
              :selectData="statusList"
              selectType="selectFilter"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
            />
          </template>
          <div slot="operation" slot-scope="{ text, record }" class="operation-btn">
            <a v-if="!isEdit || currentId !== record.id" v-hasPermi="['mdm:colorList:edit']" @click="handleEdit(record)">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
            <a class="ml10" @click="handleLog(record)">日志</a>
          </div>
        </ls-api-table>
      </div>
      <operation-log-model ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import cacheRequest from '@/mixins/cacheRequest'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import ImportExcel from "@/components/ImportExcel/importExcel"
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'
import moment from 'moment'
import {
  apiMaterialMatchColorPrepareConfigEdit,
  apiMaterialMatchColorPrepareConfigExport,
  apiMaterialMatchColorPrepareConfigList, apiRefreshMaterialColorRelation
} from '@/api/color-management/material-match-color-prepare-config-list/MaterialMatchColorPrepareConfigListApi'
import { apiGetLog } from '@/api/mes/productionPrepare/teamManage'

export default {
  name: 'MaterialMatchColorPrepareConfigList',
  components: { DownloadModal, ImportExcel, OperationLogModel },
  mixins: [cacheRequest],
  data() {
    return {
      apiMaterialMatchColorPrepareConfigExport,
      logLoading: false, // 日志loading
      logList: [], // 日志列表
      isEdit: false,
      currentId: "",
      loading: false,
      statusList: [], // 状态
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/mdm/materialMatchColorPrepareConfig/import' // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'mdm/materialMatchColorPrepareConfig/template',
        name: `真仿皮预留配色列配置导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiMaterialMatchColorPrepareConfigList, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        primaryItemCode: undefined,
        secondaryItemCode: undefined,
        toNo: undefined,
        status: undefined,
        createTime: undefined,
        createTimeStart: undefined,
        createTimeEnd: undefined,
        createBy: undefined
      },
      formList: [
        { label: '材料编码1(主)', decorator: ['primaryItemCode'], type: 'input' },
        { label: '材料编码2(辅)', decorator: ['secondaryItemCode'], type: 'input' },
        { label: 'TO号', decorator: ['toNo'], type: 'input' },
        { label: '状态', decorator: ['status'], type: 'statusList' },
        {
          label: '创建时间',
          type: 'range',
          decorator: ['createTime'],
          disposeFormat: {
            createTimeStart: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
            createTimeEnd: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
          }
        },
        { label: '创建人', decorator: ['createBy'], type: 'createBy' }
      ],
      // 表格字段
      columns: [
        { title: '材料编码1(主)', dataIndex: 'primaryItemCode', align: 'center', width: 120 },
        { title: '材料名称1(主)', dataIndex: 'primaryItemName', align: 'center', width: 180 },
        { title: '材料编码2(辅)', dataIndex: 'secondaryItemCode', align: 'center', scopedSlots: { customRender: 'secondaryItemCode' }, width: 120 },
        { title: '批次号(主)', dataIndex: 'primaryBatchNo', align: 'cen ter', scopedSlots: { customRender: 'primaryBatchNo' }, width: 120 },
        { title: 'TO号', dataIndex: 'toNo', align: 'center', scopedSlots: { customRender: 'toNo' }, width: 120 },
        { title: '数量(主)', dataIndex: 'qty', align: 'center', scopedSlots: { customRender: 'qty' }, width: 100 },
        { title: '状态', dataIndex: 'status', align: 'center', scopedSlots: { customRender: 'status' }, width: 100 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 110 },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 110 },
        { title: '备注', dataIndex: 'description', align: 'center', width: 140 },
        {
          title: '操作',
          width: 120,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created() {
    this.cacheLookupRequest('MDM_MATERIAL_MATCH_COLOR_STATUS', { lookupType: 'MDM_MATERIAL_MATCH_COLOR_STATUS', current: 1, pageSize: 999 }, 'statusList')
  },
  mounted() {
    this.loading = false;
    this.onSearch()
  },
  methods: {
    // 导入弹窗
    handleImport() {
      this.$refs.importExcelRef.show()
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    // 操作日志弹窗
    handleLog(row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show()
      apiGetLog({ id: row.id, type: 13 }).then(res => {
        if (res?.code === 200) {
          if (res?.data?.length > 0) { this.logList = res.data }
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    // 编辑-保存
    handleSave (record) {
      apiMaterialMatchColorPrepareConfigEdit(record).then(res => {
        if (res?.code === 200) {
          this.$message.success('保存成功')
          this.handleOk(true)
        } else {
          this.$message.error(res?.msg || '保存失败')
        }
      })
    },
    // 刷新
    onRefresh() {
      this.loading = true;
      apiRefreshMaterialColorRelation().then(res => {
        if (res?.code === 200) {
          this.$message.success('刷新成功')
          this.handleOk(true)
        } else {
          this.$message.error(res?.msg || '刷新失败')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false;
      this.currentId = '';
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 取消
    handleCancel () {
      this.handleOk(true)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        primaryItemCode: undefined,
        primaryBatchNo: undefined,
        primaryRkDate: undefined,
        primaryRkDateStart: undefined,
        primaryRkDateEnd: undefined,
        secondaryItemCode: undefined,
        secondaryBatchNo: undefined,
        secondaryRkDate: undefined,
        secondaryRkDateStart: undefined,
        secondaryRkDateEnd: undefined,
        matchColorCode: undefined,
        matchColorDate: undefined,
        matchColorDateStart: undefined,
        matchColorDateEnd: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    }
  }
}
</script>

<style scoped lang="less">
.operation-btn{
  display: flex;
  justify-content: center;
  .ant-btn{
    padding: 0 4px;
  }
  .ant-btn-link:focus, .ant-btn-link:hover {
    border-color: transparent !important;
  }
}
</style>
